import { defineComponent, useTemplateRef, ref, shallowRef, openBlock, createElementBlock, Fragment, createVNode, unref, withCtx, createTextVNode, normalizeStyle, mergeProps } from 'vue';
import _sfc_main$1 from '../../../component/dialog/dialog.vue.js';
import '@ssml-editor/core';
import { Button } from '@ssml-editor/vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
import '@ssml-editor/modules';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
import { useElementBounding } from '../../../node_modules/.pnpm/@vueuse_core@14.2.1_vue@3.5.31_typescript@5.9.3_/node_modules/@vueuse/core/dist/index.js';
import { SoundContentData } from './data.js';
import SoundContent from './sound-event-content.js';
import { SoundEventMenuService } from './sound-event-menu-service.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "sound-event-menu",
  props: {
    categoryPageSize: {},
    soundPageSize: {},
    fetchSounds: { type: Function },
    fetchCategories: { type: Function },
    searchSounds: { type: Function },
    editor: {}
  },
  setup(__props) {
    const menuBarButtonRef = useTemplateRef("menu-bar-button");
    const soundContentRef = useTemplateRef("sound-content");
    const dialogVisible = ref(false);
    const soundMenuService = shallowRef();
    const soundContentData = ref(new SoundContentData());
    const { x, y, height } = useElementBounding(menuBarButtonRef);
    const margin = ref("");
    const props = __props;
    function show() {
      margin.value = `${y.value + height.value}px 0 0 ${x.value}px`;
      dialogVisible.value = true;
    }
    function hide() {
      dialogVisible.value = false;
    }
    function menuClickHandler() {
      const editor = props.editor;
      if (editor) {
        soundMenuService.value ??= new SoundEventMenuService(editor);
        if (!soundMenuService.value.isDisabled()) {
          show();
        }
      }
    }
    function submitHandler() {
      const data = soundContentRef.value?.getData();
      if (data?.sound) {
        soundMenuService.value?.setNode(data.sound, data.mark);
      }
      hide();
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(Button), {
          ref: "menu-bar-button",
          "icon-class": "iconfont-ssml-editor icon-ssml-editor-shengyin",
          onClick: menuClickHandler
        }, {
          default: withCtx(() => [
            createTextVNode("插入声音")
          ]),
          _: 1
        }, 512),
        createVNode(unref(_sfc_main$1), {
          title: "插入声音",
          width: "calc(var(--el-dialog-padding-primary) * 2 + 12.5rem)",
          "destroy-on-close": true,
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": ($event) => dialogVisible.value = $event,
          style: normalizeStyle({ margin: margin.value }),
          onSubmit: submitHandler
        }, {
          default: withCtx(() => [
            createVNode(SoundContent, mergeProps({
              ref: "sound-content",
              modelValue: soundContentData.value,
              "onUpdate:modelValue": ($event) => soundContentData.value = $event
            }, props), null, 16, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "style"])
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=sound-event-menu.vue.js.map
